/* unplugin-vue-components disabled */import script from "./ProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductTable.vue?vue&type=script&setup=true&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=ad1c4690&lang=scss"

const __exports__ = script;

export default __exports__